export const DATE_PICKER_FORMAT = 'D.M.YYYY';
